var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.605992 11C0.436674 10.9997 0.275265 10.9283 0.161145 10.8032C0.0449212 10.6791 -0.012831 10.5113 0.00240097 10.3419L0.150281 8.71539L6.98172 1.88449L9.11662 4.01938L2.28699 10.8497L0.660919 10.9976C0.642207 10.9994 0.623496 11 0.605992 11ZM9.54276 3.59252L7.40846 1.45764L8.68868 0.177074C8.80189 0.063702 8.95552 0 9.11572 0C9.27592 0 9.42954 0.063702 9.54276 0.177074L10.823 1.45764C10.9363 1.57088 11 1.72455 11 1.8848C11 2.04504 10.9363 2.19871 10.823 2.31195L9.54336 3.59192L9.54276 3.59252Z",
    fill: "#0C82DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f16943479a26a10a503bf6c16e962bae.svg";
export { ForwardRef as ReactComponent };